module.exports = __webpack_public_path__ + "video/900_KMSAT15_2022_HR_Macros_Attack.5b7c2114.vtt";